import axiosClient from "../../../../../system/helpers/axiosConfig";

export const getFaq = (id) => {
  return axiosClient.get(`api/admin/faq/${id}`).then((r) => r.data);
};
